// extracted by mini-css-extract-plugin
module.exports = {"container":"Section7_container__iJVkm","content":"Section7_content__qf3pg","headline":"Section7_headline__25Xty","subHeadline":"Section7_subHeadline__KNwow"};